// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ll-1";
export var messageSideRight = "_ll-2";
export var orderLookupBubbleContainer = "_ll-0";
export var submitButton = "_ll-3";